<footer class="footer">
  <div class="d-sm-flex justify-content-center">
    <span class="text-muted text-center text-sm-left d-block d-sm-inline-block">Copyright © {{getcurrentYear}}. All rights reserved.</span>
  </div>
</footer>
